import React, { useContext } from 'react'
import { BsFillLightningChargeFill } from 'react-icons/bs';
import { Link } from 'react-router-dom'
import Card from '../component/ui/Card';
import UserContext from '../store/UserContext';
import d19 from './NotSubscribed.module.css'

function NotSubscribed() {


  const userCtx = useContext(UserContext);
    return (
        <div className={d19.NotSubscribed}>
            <div className={d19.text}> Your account is not active anymore!  </div> 

            <div className={d19.Kindly}>Unfortunately your account was expired, Kindly subscribe to activate it again</div>

<Card className='px-4 py-3'>
            <div>Expiry Date: <b>{userCtx.user.expiry_date !== undefined ? userCtx.user.expiry_date.toDate().toString().substring(0,15):null}</b> </div> 
             <div>Credits remaining: <b>{userCtx.user.credits}</b> </div>

             </Card>    
            <div className={d19.Click}> Click below to request a subscription payment </div>
          
          <Link to='/subscription-form' className={d19.button}> Request A Payment  <BsFillLightningChargeFill/> </Link>

        </div>
    )
}

export default NotSubscribed
